<template>
    <div class="container">
        
        <!-- Blocked List -->
        <div class="row my-5">
            <div class="col-12">
                <div class="card bg-white">
                    <div class="card-body">
                        <form v-if="user">
                            <dl class="row">
                                <dt class="col-12"><h3 class="mb-3 nav-settings-head text-dark-green">Blocked List</h3></dt>
                            </dl>
                            <div class="table-responsive">
                                <table class="table table-striped">
                                    <thead class="bg-silver">
                                        <tr>
                                            <th scope="col">No.</th>
                                            <th scope="col">Names</th>
                                            <th scope="col">Since</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="myBlockedUsers">
                                        <tr v-for="(blocked, i) in myBlockedUsers" :key="i">
                                            <td>{{i + 1}}.</td>
                                            <td class="text-capitalize">
                                                {{blocked.name}} <span class="text-muted text-lowercase mx-1">@{{blocked.handle}}</span>
                                            </td>
                                            <td>{{blocked.time | moment("MMM D 'YY")}}</td>
                                            <td>
                                                <button @click.prevent="unblockUserFxn(blocked.id)" class="loadn btn btn-light text-danger btn-sm">
                                                    <i class="fas fa-unlock fa-xs"></i> Unblock
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mt-3 mb-n3">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center mb-n4 p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <!-- User Preferences -->
        <div v-if="userPrefs" class="row my-5">
            <div class="col-12">
                <div class="card bg-white">
                    <div class="card-body">
                        <form>
                            <dl class="row">
                                <dt class="col-12"><h3 class="mb-3 nav-settings-head text-dark-green">Preferences</h3></dt>
                            </dl>
                            <div class="form-group">
                                <label for="newPostsChkbox" class="mx-2 clickable">
                                    <input v-model="newPosts" type="checkbox" name="newPosts" id="newPostsChkbox"> 
                                    Notify me via email when people I follow posts a new item
                                </label> 
                            </div>
                            <div class="form-group">
                                <label for="callMeChkbox" class="mx-2 clickable">
                                    <input v-model="callMe" type="checkbox" name="callMe" id="callMeChkbox"> 
                                    Show my phone number on my items for buyers to reach me
                                </label> 
                            </div>
                            <button @click.prevent="updatePreferencesFxn" 
                            class="loadn btn btn-dark-green btn-sm col-lg-2 col-md-4 col-sm-6 col-12">Save Changes</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    name: "Privacy",
    data() {
        return {
            callMe: false,
            newPosts: false,
            msg: '',
            color: 'danger'
        }
    },
    methods: {
        ...mapActions(['unblockUser', 'preferenceSetup', 'fetchPreferences']),
        unblockUserFxn(blockId) {
            let userObj = {
                userId: this.user._id,
                unblockId: blockId
            }
            this.unblockUser(userObj).then(() => {}).catch((e) => {})
        },
        updatePreferencesFxn() {
            let userObj = {
                userId: this.user._id,
                callMe: this.callMe,
                newPosts: this.newPosts,
            }
            this.preferenceSetup(userObj)
            .then((data) => {
                if(!data.error){
                    this.color = 'success'
                }
                this.msg = data.msg
            })
            .catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['user', 'myBlockedList', 'userPreferences']),
        myBlockedUsers() {
            if(this.myBlockedList && this.myBlockedList.length) {
                return this.myBlockedList
            }
            return false
        },
        userPrefs() {
            if(this.userPreferences && this.userPreferences !== null){
                this.callMe = this.userPreferences.callMe
                this.newPosts = this.userPreferences.newPosts
            }
            return true
        }
    },
    created() {
        this.fetchPreferences()
    }
}
</script>